import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=707fcb92&scoped=true&"
import script from "./Pane.vue?vue&type=script&lang=js&"
export * from "./Pane.vue?vue&type=script&lang=js&"
import style0 from "./Pane.vue?vue&type=style&index=0&id=707fcb92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707fcb92",
  null
  
)

export default component.exports